import { render, staticRenderFns } from "./potDiagramm.vue?vue&type=template&id=eb793c18&scoped=true&"
import script from "./potDiagramm.vue?vue&type=script&lang=js&"
export * from "./potDiagramm.vue?vue&type=script&lang=js&"
import style0 from "./potDiagramm.vue?vue&type=style&index=0&id=eb793c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb793c18",
  null
  
)

export default component.exports